import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {MatTableDataSource} from "@angular/material/table";
import {Subject} from "rxjs";
import {BackendListModel} from "src/app/models/common/list.model";
import {ApiRoutes} from "src/app/services/apiroutes";
import {RequestListRootObject} from "./new-request.model";
import {RequestFiltersClass} from "src/app/models/request-filters";

@Injectable({
    providedIn: 'root'
})

export class MyOrdersService {
    base_url = ApiRoutes.LeadRequest;
    newRequests: MatTableDataSource<any>;
    _defaultEmptyMessage = 'No data to display';

    newRequestPageSize = 10;
    newRequestPageNum = 1;
    newRequestPageLength = 0;
    groupInfo = {};
    filterSubject = new Subject<{}>();
    filtersAdded: boolean = false;
    listQPModel = new RequestFiltersClass();

    constructor(
        private http: HttpClient
    ) {

    }

    _emptyMessage = null;
    get emptyMessage() {
        if (this._emptyMessage)
            return this._emptyMessage;
        return this._defaultEmptyMessage;
    };

    set emptyMessage(val) {
        this._emptyMessage = val;
    }

    refreshNewRequests() {
        this.emptyMessage = null;
        this.newRequests = new MatTableDataSource<any>([]);
    }

    getNatureOfRequest(request: any) {

        switch (request.request_type.dev_name) {
            case 'lease':
                if (request.transaction_type == 'use')
                    return 'Lease | Use';
                else
                    return 'Lease | Supply';
            case 'one_way':
                if (request.transaction_type == 'use')
                    return 'One Way | Use';
                else
                    return 'One Way | Supply';
            case 'buy_sell':
                if (request.transaction_type == 'use')
                    return 'Trade | Buy';
                else
                    return 'Trade | Sell';
            case 'empty_repo':
                if (request.transaction_type == 'use')
                    return 'Empty Repo | Use';
                else
                    return '';
        }
        return '-';
    }

    getRequestDetails(searchTerm = null, requestType = null) {
        this.emptyMessage = null;
        let url = new URL(`${this.base_url}request_details/`);

        if (searchTerm) {
            url.searchParams.append('search', searchTerm);
            this.newRequestPageNum = 1;
        }
        if (requestType) {
            url.searchParams.append('request_type', requestType);
            this.newRequestPageNum = 1;
        }
        url.searchParams.append('page_size', String(this.newRequestPageSize));
        url.searchParams.append('page', String(this.newRequestPageNum));

        this.http.get<BackendListModel<any>>(url.toString()).subscribe({
            next: response => {
                this.newRequests = new MatTableDataSource(response.results);
                this.newRequestPageLength = response.count;
            },
            error: error => {
                this.emptyMessage = 'Something went wrong. Please refresh the page';
                return error;
            }
        });
    }


    // getRequestDetailsByGroup(groupId = null, searchTerm = null, page_size = 10, page = 1, order = '') {
    //   this.emptyMessage = null;
    //   let url = new URL(`${this.base_url}request_details/`);

    //   if (searchTerm) {
    //     url.searchParams.append('search', searchTerm);
    //   }
    //   if (groupId) {
    //     url.searchParams.append('group_id', groupId);
    //   }
    //   url.searchParams.append('page_size', String(page_size));
    //   url.searchParams.append('page', String(page));
    //   url.searchParams.append('o', String(order));

    //   return this.http.get<BackendListModel<any>>(url.toString());
    // }

    getRequestDetailsByFilters(groupId, RequestFiltersParams) {
        this.emptyMessage = null;
        let url = new URL(`${this.base_url}request_details/`);

        if (RequestFiltersParams.search != null && RequestFiltersParams.search != '') {
            url.searchParams.append('search', RequestFiltersParams.search);
        }
        if (RequestFiltersParams.request_type != null && RequestFiltersParams.request_type != '') {
            url.searchParams.append('request_type', RequestFiltersParams.request_type);
        }
        if (groupId != null) {
            url.searchParams.append('group_id', groupId);
        }
        if (RequestFiltersParams.request_number != null) {
            url.searchParams.append('request_number', RequestFiltersParams.request_number?.request_number);
        }
        if (RequestFiltersParams.requestor__name != null && RequestFiltersParams.requestor__name != '') {
            url.searchParams.append('requestor__name', RequestFiltersParams.requestor__name.name);
        }
        if (RequestFiltersParams.pickup_location_id != null) {
            url.searchParams.append('pickup_location_id', RequestFiltersParams.pickup_location_id.id);
        }
        if (RequestFiltersParams.dropoff_location_id != null) {
            url.searchParams.append('dropoff_location_id', RequestFiltersParams.dropoff_location_id.id);
        }
        if (RequestFiltersParams.container_size_type_id != null) {
            url.searchParams.append('container_size_type_id', RequestFiltersParams.container_size_type_id);
        }
        if (RequestFiltersParams.condition_id != null) {
            url.searchParams.append('condition_id', RequestFiltersParams.condition_id);
        }
        if (RequestFiltersParams.request_date__gte != null) {
            url.searchParams.append('request_date__gte', RequestFiltersParams.request_date__gte);
        }
        if (RequestFiltersParams.request_date__lte != null) {
            url.searchParams.append('request_date__lte', RequestFiltersParams.request_date__lte);
        }
        if (RequestFiltersParams.external_reference_no != null) {
            url.searchParams.append('external_reference_no', RequestFiltersParams.external_reference_no);
        }
        if (RequestFiltersParams.requestor__company != null && RequestFiltersParams.requestor__company != '') {
            url.searchParams.append('requestor__company', RequestFiltersParams.requestor__company);
        }
        if (RequestFiltersParams.request_age_in_days != null) {
            url.searchParams.append('request_age_in_days', RequestFiltersParams.request_age_in_days);
        }
        if (RequestFiltersParams.request_source != null) {
            url.searchParams.append('request_source', RequestFiltersParams.request_source);
        }
        if (RequestFiltersParams.page_size != null) {
            url.searchParams.append('page_size', String(RequestFiltersParams.page_size));
        }
        if (RequestFiltersParams.page != null) {
            url.searchParams.append('page', String(RequestFiltersParams.page));
        }
        if (RequestFiltersParams.o != null && RequestFiltersParams.o != '') {
            url.searchParams.append('o', RequestFiltersParams.o);
        }

        return this.http.get<BackendListModel<RequestListRootObject>>(url.toString());
    }

    updateFilterSubjectValue(filterResponse): void {
        this.filterSubject.next(filterResponse);
    }
}
